//  Hero carousel 
const heroCarousel = document.querySelectorAll('.js-hero-carousel')
if (heroCarousel.length) {
  heroCarousel.forEach(function (el, index) {
    el.classList.add(`s${index}`);
    new Swiper(`.js-hero-carousel.s${index}`, {
      slidesPerView: 1,
      autoplay: (el.dataset.autoplay == 'true') ? { delay: el.dataset.speed, disableOnInteraction: false } : false,
      effect: "fade",
      a11y: false,
      // slideActiveClass: "swiper-slider-active-slide",
      fadeEffect: {
        crossFade: true
      },
      autoplayDisableOnInteraction: false,
      loop: true,
      pagination: {
        el: `.js-hero-carousel.s${index} .swiper-pagination`,
        clickable: true
      }
    })
  })
} 

// Product carousel 
const productCarousel = document.querySelectorAll('.js-proudct-carousel');
if (productCarousel.length) {
    productCarousel.forEach(function (el, index) {
    el.classList.add(`s${index}`);
    new Swiper(`.js-proudct-carousel.s${index}`, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: true,
      mousewheel: {
          forceToAxis: true,
      },
      breakpoints: {
        0: {
          spaceBetween: 20,
        },
        769: {
            spaceBetween: 30,
        },
        1025: {
            spaceBetween: 40,
        }
    },
      pagination: {
        el: `.js-proudct-carousel.s${index} .swiper-pagination`,
        clickable: true,
      },
      navigation: {
        nextEl: `.js-proudct-carousel.s${index} .swiper-button-next`,
        prevEl: `.js-proudct-carousel.s${index} .swiper-button-prev`,
      },
    });
      const Heightselector = el.closest('.featured-collections-carousel').querySelector('.featured-collections-carousel__item.is-selected .js-proudct-carousel .swiper-slide img');
    if (Heightselector){
      const height = el.closest('.featured-collections-carousel').querySelector('.featured-collections-carousel__item.is-selected .js-proudct-carousel .swiper-slide img').offsetHeight;
      let top_position = (height / 2) + 2;
      el.querySelector('.swiper-button-next').style.top = top_position  + 'px';
      el.querySelector('.swiper-button-prev').style.top = top_position  + 'px';

      window.addEventListener('resize', function(event) {
          const height_resize = el.querySelectorAll('.swiper-slide')[0].querySelector('img').offsetHeight;
          let resize_top_position = (height_resize / 2) + 2;
          el.querySelector('.swiper-button-next').style.top = resize_top_position + 'px';
          el.querySelector('.swiper-button-prev').style.top =resize_top_position + 'px';
      }, true);
    }
  });
}

// HOT SPOT BUTTON PRODUCT TOGGLE 

const Hotspot_button = document.querySelectorAll('.hotspot-product-main .hotspot-product-items button');
const Hotspot_toggle_div = document.querySelectorAll('.hotspot-product-main .hotspot-product-items .hotspot-product-content');
Hotspot_button.forEach((button, index) => button.addEventListener("click", () =>{
  Hotspot_toggle_div.forEach((div, divIndex) => {
    if (divIndex !== index) {
      div.classList.add('hidden');
    }
  });
  Hotspot_toggle_div[index].classList.toggle('hidden');

}));
// TWO IMAGE FULL WIDTH 



// document.addEventListener('click', function(event) {
//   const isHotspotButtonClick = event.target.matches('.hotspot-product-main .hotspot-product-items button');
//   const isHotspotDivClick = event.target.matches('.hotspot-product-main .hotspot-product-items .hotspot-product-content');

//   if (!isHotspotButtonClick && !isHotspotDivClick) {
//     Hotspot_toggle_div.forEach(div => div.classList.add('hidden'));
//   }
// });


// CONTENT GRID

var ContentgridCarousel = document.querySelectorAll('.js-content-grid-carousel');
var media = window.matchMedia('(min-width: 769px)');

function initSliders() {
  if (!media.matches) {
    ContentgridCarousel.forEach(function (el, index) {
      if (!el.swiper) {
        el.classList.add(`s${index}`);
        el.swiper = new Swiper(el, {
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
          a11y: false,
          slidesPerView: 'auto',
          spaceBetween: 20,
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
          },
        });
      }
    });
  }
}

function destroySliders() {
  ContentgridCarousel.forEach(el => {
    if (el.swiper) {
      el.swiper.destroy(true, true);
      el.swiper = null;
    }
  });
}

function handleMediaChange(e) {
  if (e.matches) {
    destroySliders();
  } else {
    initSliders();
  }
}

initSliders();

media.addListener(handleMediaChange);


// Image Height for container

const Container_heights = document.querySelectorAll('.two-column-with-full-text .two-column-with-full-text-wrapepr .tow-columns-items .media-wrapper-main');

function UpdateImageHeight() {
    const screenWidth = window.innerWidth;

    if (screenWidth > 1025) {
      const Two_image = document.querySelector('.two-column-with-full-text .two-column-with-full-text-wrapepr .column-1 .desktop_media .image');
      const Two_video = document.querySelector('.two-column-with-full-text .two-column-with-full-text-wrapepr .column-1 .desktop_media .video');
      let Tow_image_height;
      if (Two_image){
         Tow_image_height = Two_image.offsetHeight;
      }
      else if(Two_video){
         Tow_image_height = Two_video.offsetHeight;
      } else {
        Tow_image_height = 0;
      }
        Container_heights.forEach(container => {
            container.style.setProperty('--colomn-image-height', Tow_image_height + 'px');
        });
    } else if (screenWidth >= 767 && screenWidth <= 1024) {
      const Two_image = document.querySelector('.two-column-with-full-text .two-column-with-full-text-wrapepr .column-1 .tablet_media .image');
      const Two_video = document.querySelector('.two-column-with-full-text .two-column-with-full-text-wrapepr .column-1 .desktop_media .video');
        let Tow_image_height= 0;
      if (Two_image){
         Tow_image_height = Two_image.offsetHeight;
      }
      else if(Two_video){
         Tow_image_height = Two_video.offsetHeight;
      } else {
        Tow_image_height = 0;
      }
        Container_heights.forEach(container => {
            container.style.setProperty('--colomn-image-height', Tow_image_height + 'px');
        });
    }
}


UpdateImageHeight();

window.addEventListener('resize', function(event) {
    UpdateImageHeight();
}, true);

// container center while sticky 

const Image_content = document.querySelectorAll('.two-column-with-full-text .two-column-with-full-text-wrapepr.two-cols-sticky-text .tow-columns-items .column-content-wrapper .column-content');
const ImageWrapperHeight = document.querySelectorAll('.two-column-with-full-text .two-column-with-full-text-wrapepr.two-cols-sticky-text .tow-columns-items .column-content-wrapper');

function updateHeights() {
  if (window.innerWidth > 1025) {
      if (Image_content.length === ImageWrapperHeight.length) {
          Image_content.forEach((content, index) => {
              const contentHeight = content.offsetHeight;
              const Two_image = document.querySelector('.two-column-with-full-text .two-column-with-full-text-wrapepr .column-1 .media-wrapper-main img');
              const Tow_image_height = Two_image ? Two_image.offsetHeight : 0;
              const image_height = Tow_image_height / 2;
              const content_height = contentHeight / 2;
              ImageWrapperHeight[index].style.height = image_height + content_height + 'px';
          });
      } 
  }
}
updateHeights();

window.addEventListener('resize', function() {
    updateHeights();
}, true);

$(document).ready(function(){
  if($('.stories-slider-section .stories-slider-outer').length){
    $('.stories-slider-section .stories-slider-outer').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 2,
      rows: 0,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  if($('.featured-products-slider .product-slider-section').length){
    $('.featured-products-slider .product-slider-section').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0,
      dots: true,
      arrows: true
    });
  }

  if($('form[id^="product-form-main-"]').length){

    let searchParams_static = new URLSearchParams(window.location.search);
    let variant_id_static = searchParams_static.get('variant');
    if(variant_id_static !== null){
        $('.variants-gallery').show();
        $('.variants-gallery .variant-gallery-item').hide();
        $('.variants-gallery .variant-gallery-item#variant-'+variant_id_static).show();
        $('.product-gallery .product-gallery__image-list').addClass('gallery_main_item_showing');
    }
    
    $('body').on('variant:change', 'form[id^="product-form-main-"]', function(e){
      let searchParams = new URLSearchParams(window.location.search);
      let variant_id = searchParams.get('variant');
      
      $('.variants-gallery .variant-gallery-item').hide();
    
      if($('.variants-gallery .variant-gallery-item#variant-'+variant_id).length){
          $('.variants-gallery').show();
          $('.variants-gallery .variant-gallery-item#variant-'+variant_id).show();
          $('.product-gallery .product-gallery__image-list').addClass('gallery_main_item_showing');
      } else {
          $('.product-gallery .product-gallery__image-list').removeClass('gallery_main_item_showing');
      }
      
      window.scrollTo(0, 0);
    });
  }
});

import { PhotoSwipeLightbox } from "vendor";
const lightbox = new PhotoSwipeLightbox({
  gallery: '.variant-gallery-item[id^="variant-"]',
  children: 'a',
  pswpModule: () => import('photoswipe'),
  bgOpacity: 1,
  maxZoomLevel: 3,
  // UX
  arrowPrev: false,
  arrowNext: false,
  counter: false,
  close: false,
  zoom: false,
  showHideAnimationType: 'fade',
  objectFit: 'contain', // 🔑 This keeps images inside the lightbox bounds
});
lightbox.on('uiRegister', function() {
  lightbox.pswp.ui.registerElement({
    name: "close-button",
    className: "circle-button circle-button--xl hover:animate-icon-block",
    ariaLabel: window.themeVariables.strings.closeGallery,
    order: 2,
    isButton: true,
    html: `
        <svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16">
          <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"/>
        </svg>
      `,
    onClick: () => {
      lightbox.pswp.close();
    }
  });
});
lightbox.init();

document.addEventListener('click', function(e) {
  if (e.target.matches('.cart-remove-item')) {
    const key = e.target.getAttribute('data-line-item-key');
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(cart => {
      // Update your cart drawer UI here
      // e.g., re-render with updated cart contents
      
      // ✅ Reload the page after successful removal
      window.location.reload();
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.querySelector('a.button[href="#productModal"]');
  const modal = document.querySelector('.contact-form-modal.use_as_product_modal');

  if (trigger && modal) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      modal.style.display = 'block'; // Or use modal.classList.add('active') if using classes
    });

    // Populate the input field with current URL
    const urlField = document.querySelector('input[id$="contactproduct-url"]');
    if (urlField) {
      urlField.value = window.location.href;

      const parentControl = urlField.closest('.form-control');
      if (parentControl) {
        parentControl.style.display = 'none'; // Hides the entire form control wrapper
      }
    }
  }

  document.querySelector('.close-product-modal')?.addEventListener('click', function () {
    document.querySelector('.contact-form-modal.use_as_product_modal').style.display = 'none';
  });
});

document.addEventListener('cart-drawer:refreshed', () => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  // Wait until the shadow root is available
  const shadow = drawer.shadowRoot;
  if (!shadow) return;

  // Get the overlay shadow part
  const base = shadow.querySelector('[part="base"]');
  if (!base) return;

  // Get the overlay footer part
  const footer = shadow.querySelector('[part="footer"]');
  if (!footer) return;

  const overlayElement = shadow.querySelector('[part="overlay"]');
  if (!overlayElement) return;

  const overlayProductsContainer = drawer.querySelector('.overlay-products');
  if (!overlayProductsContainer){
    var elementCreationRemoval = $(shadow).find('[part="overlay-products"]').remove();
    var elementCreationFooterRemoval = $(footer).find("slot[name='footer-products']").remove();
    return;
  }

  const overlayProducts = shadow.querySelector('[part="overlay-products"]');
  const overlayProductsFooter = shadow.querySelector('[name="footer-products"]');
  if (overlayProductsFooter && overlayProductsFooter){
    return;
  }

  var elementCreation = $(overlayElement).after("<div class='overlay-products' part='overlay-products'><slot name='products-inner'></slot></div>");
  var elementCreationFooter = $(footer).append("<slot name='footer-products'></slot>");
});

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  // Wait until the shadow root is available
  const shadow = drawer.shadowRoot;
  if (!shadow) return;

  // Get the overlay shadow part
  const base = shadow.querySelector('[part="base"]');
  if (!base) return;

  // Get the overlay footer part
  const footer = shadow.querySelector('[part="footer"]');
  if (!footer) return;

  const overlayElement = shadow.querySelector('[part="overlay"]');
  if (!overlayElement) return;

  const overlayProducts = shadow.querySelector('[part="overlay-products"]');
  const overlayProductsFooter = shadow.querySelector('[name="footer-products"]');
  if (overlayProductsFooter && overlayProductsFooter){
    return;
  }

  const overlayProductsContainer = drawer.querySelector('.overlay-products');
  if (!overlayProductsContainer){
    return;
  }

  var elementCreation = $(overlayElement).after("<div class='overlay-products' part='overlay-products'><slot name='products-inner'></slot></div>");
  var elementCreationFooter = $(footer).append("<slot name='footer-products'></slot>");
});

const cartDrawer = document.querySelector('#cart-drawer');
if (cartDrawer) {
  const observer = new MutationObserver(() => {
    const display = window.getComputedStyle(cartDrawer).display;

    if (display === 'block') {
      document.dispatchEvent(new CustomEvent("cart_new_opened_test"));
    }
  });
  observer.observe(cartDrawer, { attributes: true, attributeFilter: ['style'] });
}

document.addEventListener('cart_new_opened_test', () => {
  triggerModalSliders();
});

document.addEventListener('cart-drawer:refreshed', () => {
  triggerModalSliders();
});

function triggerModalSliders() {

    var swiperDesktop = new Swiper('.swiper-container-desktop', {
        loop: false,
        pagination: {
            el: '.swiper-pagination-desktop',
            clickable: true,
            type: 'bullets'
        },
        navigation: {
          nextEl: '.swiper-button-next-desktop',
          prevEl: '.swiper-button-prev-desktop',
        },
        watchOverflow: true,
        slidesPerView: 3,
        slidesPerGroup: 1, // <-- IMPORTANT
        spaceBetween: 20,
        breakpoints: {
            1350: {
                slidesPerView: 3,
                slidesPerGroup: 1,
            },
            1100: {
                slidesPerView: 2,
                slidesPerGroup: 1,
            },
            900: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            300: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            }
        }
    });

    var swiperMobile = new Swiper('.swiper-container-mobiles', {
        loop: false,
        spaceBetween: 20,
        pagination: {
            el: '.swiper-pagination-mobiles',
            clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });

}

jQuery(document).ready(function ($) {

    $(window).on('scroll', function() {
      if ($(this).scrollTop() >= 40) {
        $('.header-usp-bar').addClass('fixed-down');
      } else {
        $('.header-usp-bar').removeClass('fixed-down');
      }
    });

    const screenWidth = window.innerWidth;
    if (screenWidth < 1149) {
      $('.header-usp-bar.b2b-ticker-version .usp-items').slick({
        speed: 9000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        variableWidth: true
      });
    }

    if (screenWidth < 1000) {
      $('.header-usp-bar:not(.b2b-ticker-version) .usp-items').slick({
        speed: 9000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        variableWidth: true
      });
    }

});